import { InputHTMLAttributes, ReactElement, useState, forwardRef } from 'react';

import styles from './Input.module.scss';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    error?: string
}

export const Input = forwardRef<HTMLInputElement, Props>((props, ref) => {
    const attrs = {...props};

    let label: ReactElement | undefined;

    const [focused, setFocused] = useState<boolean>(false);

    attrs.onFocus = () => {
        setFocused(true);
    }
    attrs.onBlur = () => {
        setFocused(false);
    }

    if (focused || props.value !== "" ) {
        label = <label>{props.placeholder}</label>
        if (props.error !== undefined) {
            label = <label>{props.error}</label>
        }
    }

    const classes = [
        styles['input-container'],
        props.error ? styles.error : ''
    ].join(' ')


    return (
        <div className={classes}>
            <input ref={ref} {...attrs}/>
            {label}
        </div>
    );
});

Input.displayName = 'Input';